// Third party
import React from 'react';

// Utils
import { PERMISSIONS, userHasPermissionEnabled } from '@/utils/permissions';
import FormattedMessage from '@/utils/i18n/FormattedMessage';

// Constant and types
import { RateLimitType } from '@/redux/modules/types/rate-limits';
import User from '@/types/user';

// Components
import ConnectedPrivateComponent from '@/views/components/PrivateComponent';
import RateLimitedComponent from '@/views/components/RateLimitedComponent';
import PrimaryButton from '@/views/components/buttons/PrimaryButton';

type DownloadPDFButtonProps = {
  user: User;
  downloadPdf?: () => void;
  isMobile?: boolean;
};

const DownloadPDFButton = ({ user, downloadPdf, isMobile = false }: DownloadPDFButtonProps) => (
  <ConnectedPrivateComponent permissions={[PERMISSIONS.PROPOSAL_DOWNLOAD]}>
    {() => (
      <RateLimitedComponent type={RateLimitType.PROPOSALS}>
        {({ disabled, error }) => (
          <PrimaryButton className="download-pdf-button" compact icon={isMobile ? '' : 'file-pdf'} onClick={downloadPdf} disabled={disabled} error={error}>
            <FormattedMessage
              id={`Proposal.${!userHasPermissionEnabled(user, PERMISSIONS.PROPOSAL_TOOLBOX_NEW_MENU) || isMobile ? 'DownloadFile' : 'DownloadPDFProposal'}`}
            />
          </PrimaryButton>
        )}
      </RateLimitedComponent>
    )}
  </ConnectedPrivateComponent>
);

export default DownloadPDFButton;
